<template>
    <div id="tree-node" style="font-size: 14px">
        <div
            :class="{bold: isFolder}"
            @click="toggleOrPick"
        >
            <span v-if="isFolder"><i class="acclaro-icon" v-bind:class="icon"></i></span>
            <span style="cursor: pointer">{{ item.name }}</span>
        </div>
        <ul v-show="isOpen" v-if="isFolder" style="margin-top: 0px;">
            <tree-node
                class="item"
                v-for="(child, index) in item.children"
                :key="index"
                :item="child"
            ></tree-node>
        </ul>
    </div>
</template>
<script>

    import {EventBus} from '../../../../event-bus';

    // define the tree-item component
    export default {
        props: {
            item: Object
        },
        data: function () {
            return {
                isOpen: false,
                selected: false,
                arrowDown: 'public/images/ui-icons-new/tree-arrow-down.png',
                arrowRight: 'public/images/ui-icons-new/tree-arrow-right.png'
            };
        },
        computed: {
            isFolder: function () {
                return this.item.children && this.item.children.length;
            },
            isFile: function () {
                return !(this.item.children && this.item.children.length);
            },
            icon: function () {
                return this.isOpen ? 'icon-tree-arrow-down' : 'icon-tree-arrow-right';
            }
        },
        methods: {
            toggleOrPick: function () {
                if (this.isFolder) {
                    this.isOpen = !this.isOpen;
                }
                else {
                    this.selected = true;
                    EventBus.$emit('file-picked', this.item);
                }
            },
        }
    };

</script>
